import { NetworkStats, Block, BlockTransaction, TrendingToken, TokenPrice, TransactionChartData } from '@/types/blockchain';

export const networkStats: NetworkStats = {
  totalAccounts: 351869553,
  accountsChange24h: 239742,
  totalValueLocked: 23891459016,
  tvlChange24h: 0.85,
  totalTransactions: 12315119616,
  transactionsChange24h: 10521218,
  totalTransferVolume: 23350135550682,
  volumeChange24h: 32620004307,
  currentTPS: 141,
  maxTPS: 1035,
  totalNodes: 7923,
  totalContracts: 7090082,
  totalTokens: 188087,
};

export const tokenPrice: TokenPrice = {
  symbol: 'TRX',
  price: 0.2813,
  change24h: -0.01,
  marketCap: 26.68,
  volume24h: 576.17,
  totalSupply: 94681772910,
  totalStaked: 45650303920,
  stakedChange: 0.10,
};

export const trendingTokens: TrendingToken[] = [
  { symbol: 'USDT', name: 'Tether USD' },
  { symbol: 'AiT', name: 'AI Token', icon: '🤖' },
  { symbol: 'FMC', name: 'FMC Token', icon: '💎' },
  { symbol: 'SUNDOG', name: 'SunDog', icon: '🌞' },
  { symbol: 'PePe', name: 'Pepe', icon: '🐸' },
  { symbol: 'ARES', name: 'Ares', icon: '⚔️' },
];

const generateBlockHash = () => {
  return '0x' + Array.from({ length: 12 }, () => 
    Math.floor(Math.random() * 16).toString(16)
  ).join('') + '...';
};

const generateAddress = () => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz123456789';
  return 'T' + Array.from({ length: 6 }, () => 
    chars[Math.floor(Math.random() * chars.length)]
  ).join('') + '...' + Array.from({ length: 5 }, () => 
    chars[Math.floor(Math.random() * chars.length)]
  ).join('');
};

const validators = [
  { address: 'TBinance...Staking', name: 'Binance Staking' },
  { address: 'TAbra...Capital', name: 'Abra Capital Management' },
  { address: 'TCrypto...Labs', name: 'Crypto Labs' },
  { address: 'TTron...Alliance', name: 'TRONALLIANCE' },
  { address: 'TJustin...Sun', name: 'Justin Sun' },
  { address: 'TPoloniex...', name: 'Poloniex' },
];

export const generateBlocks = (count: number): Block[] => {
  const baseBlockNumber = 78226881;
  return Array.from({ length: count }, (_, i) => {
    const validator = validators[Math.floor(Math.random() * validators.length)];
    return {
      number: baseBlockNumber - i,
      hash: generateBlockHash(),
      timestamp: new Date(Date.now() - i * 3000),
      validator: validator.address,
      validatorName: validator.name,
      transactionCount: Math.floor(Math.random() * 400) + 100,
      reward: 8,
      burned: Math.floor(Math.random() * 80) + 50,
      bandwidth: 128,
    };
  });
};

export const generateTransactions = (count: number): BlockTransaction[] => {
  const types: BlockTransaction['type'][] = ['Transfer TRX', 'Transfer Token', 'Contract Call', 'Delegate Resource'];
  
  return Array.from({ length: count }, (_, i) => ({
    hash: generateAddress().replace('T', 'e').slice(0, 8) + '...' + Math.random().toString(36).slice(2, 7),
    from: generateAddress(),
    to: generateAddress(),
    amount: Math.random() * 500,
    token: Math.random() > 0.3 ? 'TRX' : 'USDT',
    type: types[Math.floor(Math.random() * types.length)],
    timestamp: new Date(Date.now() - i * 6000),
  }));
};

export const transactionChartData: TransactionChartData[] = [
  { date: '11-25', totalTransactions: 8, trxTransfers: 6, usdtTransfers: 2 },
  { date: '11-27', totalTransactions: 10, trxTransfers: 7, usdtTransfers: 3 },
  { date: '11-29', totalTransactions: 7, trxTransfers: 5, usdtTransfers: 2 },
  { date: '12-01', totalTransactions: 12, trxTransfers: 8, usdtTransfers: 4 },
  { date: '12-03', totalTransactions: 9, trxTransfers: 6, usdtTransfers: 3 },
  { date: '12-05', totalTransactions: 11, trxTransfers: 7, usdtTransfers: 4 },
  { date: '12-07', totalTransactions: 14, trxTransfers: 9, usdtTransfers: 5 },
];

export const blocks = generateBlocks(10);
export const transactions = generateTransactions(10);